import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Table from "../../../core/common/dataTable/index";
import apiDefinitions from "../../../api/apiDefinitions";

import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import FileUpload from "./fileUploader";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

import { useNavigate } from "react-router-dom";

const CreateBudget = () => {
  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(40), (val, index) => currentYear + index);

  const route = all_routes;
  const navigate = useNavigate();
  const [campaignList, setCampaignList] = useState([]);
  const [year, setYear] = useState<string>("");
  const [budget, setBudget] = useState<string>("");
  const [uploadedFile, setUploadedFile] = useState<File[]>([]);
  const [fieldErrors, setFieldErrors] = useState<any>({
    year: "",
    file: "",
  });
  const [clearFileUploader, setClearFileUploader] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [initalError, setInitalError] = useState(false);
  const [roleId, setRoleId] = useState<number | undefined>(undefined);
  const [subbudgetErrors, setSubbudgetErrors] = useState<{
    [key: string]: string;
  }>({});
  const [noSubbudgetsError, setNoSubbudgetsError] = useState<string>("");
  const [activities, setActivities] = useState<Activity[]>([]);
  interface Subbudget {
    name: string;
    amount: string;
  }

  interface Activity {
    name: string;
    value: string;
    subBudgets: Subbudget[];
  }

  const [subbudgets, setSubbudgets] = useState<Subbudget[]>([]);

  const hasDataLoaded = useRef(false);

  const handleErrors = (error: any) => {
    setFieldErrors((previouseErrors: any) => {
      return { ...previouseErrors, ...error };
    });
  };

  const location = useLocation();
  const isLinkActive = (route: string) => {
    return location.pathname === route;
  };

  const handleFileSelect = (files: any) => {
    setUploadedFile(files);
  };

  const handleClear = () => {
    setYear("");
    setBudget("");
    setUploadedFile([]);
    setClearFileUploader(true);
    setSubbudgets([]);
    setSubbudgetErrors({});
    setNoSubbudgetsError("");
    setActivities([]);
    // Clear errors
    setFieldErrors({ year: "", file: "" });
  };

  useEffect(() => {
    if (clearFileUploader) {
      setClearFileUploader(false);
    }
  }, [clearFileUploader]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setEmployeeId(decodedToken.serial_number);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    console.log("file error", fieldErrors.file);
  }, [fieldErrors.file]);

  const handleSubmit = () => {
    let isvalid = true;

    if (year === "") {
      handleErrors({ year: "Year is required" });
      isvalid = false;
    }

    if (uploadedFile.length === 0) {
      handleErrors({ file: "File is required" });
      isvalid = false;
    }

    const newSubbudgetErrors: { [key: string]: string } = {};

    if (activities.length === 0) {
      toast.error("At least one activity is required.");
      isvalid = false;
    } else {
      setNoSubbudgetsError(""); // Clear the "no activities" error if activities are added

      activities.forEach((activity, activityIndex) => {
        // Check if Activity Name is empty
        if (activity.name.trim() === "") {
          newSubbudgetErrors[`activity-${activityIndex}-name`] =
            "Activity Name is required";
          isvalid = false;
        }

        // Check if Sub-Activities are empty
        if (activity.subBudgets.length === 0) {
          newSubbudgetErrors[`activity-${activityIndex}-subbudgets`] =
            "At least one sub-activity is required for this activity.";
          isvalid = false;
        }

        // Check Sub-Activity fields
        activity.subBudgets.forEach((subBudget, subBudgetIndex) => {
          let errorMessage = "";

          if (subBudget.name.trim() === "") {
            errorMessage = "Sub-Activity Type is required";
            isvalid = false;
          }

          if (subBudget.amount.trim() === "") {
            errorMessage += errorMessage
              ? " and Sub-Activity Value is required"
              : "Sub-Activity Value is required";
            isvalid = false;
          }

          if (errorMessage) {
            newSubbudgetErrors[`${activityIndex}-${subBudgetIndex}`] =
              errorMessage;
          }
        });
      });
    }

    setSubbudgetErrors(newSubbudgetErrors);

    if (fieldErrors.year === "" && fieldErrors.file === "" && isvalid) {
      // Collect all form data
      const formData = new FormData();

      if (uploadedFile && uploadedFile.length > 0) {
        uploadedFile.forEach((file) => {
          formData.append("files", file);
        });
      }

      const payload = {
        // requestBudget: budget,
        year: year,
        requestedBy: employeeId,
        approvedAmount: parseFloat(budget), // Assuming budget is the total approved amount
        approveRejectBy: "", // This can be set later when approved/rejected
        budgetActivities: activities.map((activity) => ({
          activityName: activity.name,
          amount: parseFloat(activity.value),
          subBudgets: activity.subBudgets.map((subBudget) => ({
            name: subBudget.name,
            amount: parseFloat(subBudget.amount),
          })),
        })),
      };

      console.log("Payload", payload);

      formData.append("budgetDto", JSON.stringify(payload));

      formData.forEach((value, key) => {
        console.log(key, value);
      });

      Swal.fire({
        title: "Do You Want Request New Annual Budget?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            console.log("currentTime", currentTime);
            console.log("Token", token);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Requesting budget...");
              // Token is valid, proceed with the API call
              apiDefinitions
                .createBudget(token, formData)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Requested Successfully", {
                      duration: 5000,
                    });
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Request Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  interface Budget {
    id: string;
    requestBudget: string;
    year: string;
    approvedAmount: string;
    status: { id: number; name: string; color: string }[];
    startDate: string;
    endDate: string;
  }

  interface Column {
    title: string;
    dataIndex: string;
    render?: (text: any, record: Budget) => JSX.Element;
  }

  const columns: Column[] = [
    {
      title: "Year",
      dataIndex: "year",
    },
    {
      title: "Approved Budget (LKR)",
      dataIndex: "approvedAmount",
    },
    {
      title: "Requested Budget (LKR)",
      dataIndex: "requestBudget",
    },
    {
      title: "Requested Date",
      dataIndex: "requestDate",
      render: (requestDate: string | null) => (
        <span>{requestDate ? formatDate(requestDate) : "N/A"}</span>
      ),
    },
    {
      title: "Approved Date",
      dataIndex: "presidentApproveRejectDate",
      render: (presidentApproveRejectDate: string | null) => (
        <span>
          {presidentApproveRejectDate
            ? formatDate(presidentApproveRejectDate)
            : "N/A"}
        </span>
      ),
    },
    {
      title: "Mkting. Status",
      dataIndex: "status",
      render: (status: { id: number; name: string; color: string } | null) => {
        if (status) {
          const { name, color } = status;
          return (
            <div>
              <span className={`badge badge-pill badge-status bg-${color}`}>
                {name}
              </span>
            </div>
          );
        }
        return <span>No Status</span>; // Handle case where status is null
      },
    },
    {
      title: "Approval Status",
      dataIndex: "approveRejectStatus",
      render: (approveRejectStatus: string | null) => {
        const color = "info"; // Hard code the color
        return (
          <div>
            <span className={`badge badge-pill badge-status bg-${color}`}>
              {approveRejectStatus ?? "Marketing Pending"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record: Budget) => (
        <div className="action-icons d-flex gap-2">
          {/* Eye Icon */}
          <Link
            to={`/budget/subBudgets/${record.id}`}
            className="text-info"
            title="View Sub-Budget"
          >
            <i
              className="ti ti-chart-pie"
              style={{
                fontSize: "1.8rem",
                marginLeft: "10px", // Adjust this value as needed
              }}
            ></i>
          </Link>
          <Link
            to={`/budget/approvedBudgets/viewBudget/${record.id}`}
            className="text-info"
            title="View Details"
          >
            <i
              className="ti ti-eye"
              style={{
                fontSize: "1.8rem",
                marginLeft: "10px",
              }}
            ></i>
          </Link>
        </div>
      ),
    },
  ];

  const refreshCampaigns = () => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    if (!hasDataLoaded.current) {
      hasDataLoaded.current = true;
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const toastId = toast.loading("Loading Data...");
        apiDefinitions.getApprovedBudgets(token).then((response: any) => {
          if (response.data.code === 200) {
            console.log("Campaign Categories: ", response.data.data);
            setCampaignList(response.data.data);
            toast.dismiss(toastId);
            toast.success("Data Loaded", {
              duration: 5000,
            });
          } else {
            toast.dismiss(toastId);
            toast.error("Failed to Load Data");
          }
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  useEffect(() => {
    refreshCampaigns();
  }, []);

  useEffect(() => {
    const budgetRegex = /^\d+(\.\d{2})$/;
    if (budget === "") {
      if (initalError) {
        handleErrors({ budget: "Budget is required" });
      } else {
        setInitalError(true);
      }
    } else if (!budgetRegex.test(budget)) {
      handleErrors({
        budget: "Budget must be a number with exactly two decimal places",
      });
    } else {
      handleErrors({ budget: "" });
    }
  }, [budget]);

  useEffect(() => {
    if (year === "") {
      if (initalError) {
        handleErrors({ year: "Year is required" });
      } else {
        setInitalError(true);
      }
    } else {
      handleErrors({ year: "" });
    }
  }, [year]);

  useEffect(() => {
    if (uploadedFile.length === 0) {
      if (initalError) {
        handleErrors({ file: "File is required" });
      } else {
        setInitalError(true);
      }
    } else {
      handleErrors({ file: "" });
    }
  }, [uploadedFile]);

  useEffect(() => {
    const modalElement = document.getElementById("con-close-modal");
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleClear);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleClear);
      }
    };
  }, []);

  const handleAddSubbudget = () => {
    setSubbudgets([...subbudgets, { name: "", amount: "" }]);
    setNoSubbudgetsError(""); // Clear the "no sub-budgets" error
    setSubbudgetErrors({ ...subbudgetErrors, [subbudgets.length]: "" }); // Clear error for the new sub-budget
  };

  const handleSubBudgetChange = (
    activityIndex: number,
    subBudgetIndex: number,
    field: keyof Subbudget,
    value: string
  ) => {
    const updatedActivities = [...activities];

    if (field === "amount") {
      // Validate and process the amount field (numbers only)
      const numericValue = value.replace(/,/g, ""); // Remove commas
      const isValidNumber = /^\d*\.?\d*$/.test(numericValue); // Allow numbers and optional decimal point

      if (!isValidNumber) {
        // If the input is not a valid number, ignore it
        return;
      }

      updatedActivities[activityIndex].subBudgets[subBudgetIndex][field] =
        numericValue;

      // Recalculate the total for the activity
      const total = updatedActivities[activityIndex].subBudgets.reduce(
        (sum, subBudget) => {
          const amount = parseFloat(subBudget.amount);
          return sum + (isNaN(amount) ? 0 : amount);
        },
        0
      );

      updatedActivities[activityIndex].value = total.toFixed(2); // Update the activity value
    } else if (field === "name") {
      // Allow any input for the name field
      updatedActivities[activityIndex].subBudgets[subBudgetIndex][field] =
        value;
    }

    setActivities(updatedActivities);

    // Recalculate the total budget
    const totalBudget = calculateTotalBudget(updatedActivities);
    setBudget(totalBudget);
  };

  const handleDeleteSubBudget = (
    activityIndex: number,
    subBudgetIndex: number
  ) => {
    const updatedActivities = [...activities];
    updatedActivities[activityIndex].subBudgets.splice(subBudgetIndex, 1);

    // Recalculate the total for the activity
    const total = updatedActivities[activityIndex].subBudgets.reduce(
      (sum, subBudget) => {
        const amount = parseFloat(subBudget.amount);
        return sum + (isNaN(amount) ? 0 : amount);
      },
      0
    );

    updatedActivities[activityIndex].value = total.toFixed(2); // Update the activity value
    setActivities(updatedActivities);

    // Recalculate the total budget
    const totalBudget = calculateTotalBudget(updatedActivities);
    setBudget(totalBudget);
  };

  const calculateTotalBudget = (activities: Activity[]): string => {
    let total = 0;
    activities.forEach((activity) => {
      const value = parseFloat(activity.value);
      if (!isNaN(value)) {
        total += value;
      }
    });
    return total.toFixed(2); // Return the total as a string with two decimal places
  };

  const calculateTotalActivityBudget = (activities: Activity[]): string => {
    let total = 0;
    activities.forEach((activity) => {
      activity.subBudgets.forEach((subBudget) => {
        const amount = parseFloat(subBudget.amount);
        if (!isNaN(amount)) {
          total += amount;
        }
      });
    });
    return total.toFixed(2); // Return the total as a string with two decimal places
  };

  const calculateSubBudgetTotal = (subBudgets: Subbudget[]): string => {
    let total = 0;
    subBudgets.forEach((subBudget) => {
      const amount = parseFloat(subBudget.amount);
      if (!isNaN(amount)) {
        total += amount;
      }
    });
    return total.toFixed(2); // Return the total as a string with two decimal places
  };

  useEffect(() => {
    const totalBudget = calculateTotalBudget(activities);
    setBudget(totalBudget);
  }, [activities]);

  const handleAddActivity = () => {
    const updatedActivities = [
      ...activities,
      { name: "", value: "", subBudgets: [] },
    ];
    setActivities(updatedActivities);
    const totalBudget = calculateTotalBudget(updatedActivities);
    setBudget(totalBudget);
  };

  // Remove this function
  const handleActivityChange = (
    index: number,
    field: keyof Activity,
    value: string
  ) => {
    const updatedActivities = [...activities];
    if (field === "name" || field === "value") {
      updatedActivities[index][field] = value;
    }
    setActivities(updatedActivities);
    const totalBudget = calculateTotalBudget(updatedActivities);
    setBudget(totalBudget);
  };

  const handleDeleteActivity = (index: number) => {
    const updatedActivities = activities.filter((_, i) => i !== index);
    setActivities(updatedActivities);
  };

  const handleAddSubBudgetToActivity = (activityIndex: number) => {
    const updatedActivities = [...activities];
    updatedActivities[activityIndex].subBudgets.push({ name: "", amount: "" });

    // Recalculate the total for the activity
    const total = updatedActivities[activityIndex].subBudgets.reduce(
      (sum, subBudget) => {
        const amount = parseFloat(subBudget.amount);
        return sum + (isNaN(amount) ? 0 : amount);
      },
      0
    );

    updatedActivities[activityIndex].value = total.toFixed(2); // Update the activity value
    setActivities(updatedActivities);

    // Recalculate the total budget
    const totalBudget = calculateTotalBudget(updatedActivities);
    setBudget(totalBudget);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      setRoleId(decodedToken.role_id); // Set the role_id in state
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">Annual Budget</h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              <div className="campaign-tab">
                <ul className="nav">
                  <li>
                    <Link
                      to={route.createBudget}
                      className={
                        isLinkActive(route.createBudget) ? "active" : ""
                      }
                    >
                      Approved Budgets
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={route.PenddingBudgets}
                      className={
                        isLinkActive(route.PenddingBudgets) ? "active" : ""
                      }
                    >
                      Pending Budgets
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={route.RejectedBudgets}
                      className={
                        isLinkActive(route.RejectedBudgets) ? "active" : ""
                      }
                    >
                      Rejected Budgets
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Campaign Tab */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="row align-items-center justify-content-between">
                      {/* Search Bar aligned to the Left */}
                      <div className="col-sm-6">
                        {/* <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Campaign"
                            onChange={(e) => setSearchKey(e.target.value)}
                          />
                        </div> */}
                      </div>

                      {/* Button aligned to the Right */}
                      <div
                        className="modal fade"
                        id="con-close-modal"
                        tabIndex={-1}
                        aria-labelledby="con-close-modal-label"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog"
                          style={{ maxWidth: "1200px" }}
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="con-close-modal-label"
                              >
                                Request New Budget for Year
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body p-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label
                                      htmlFor="field-1"
                                      className="form-label"
                                    >
                                      Year
                                    </label>
                                    <select
                                      className="form-control"
                                      id="field-1"
                                      value={year}
                                      onChange={(e) => setYear(e.target.value)}
                                    >
                                      <option value="" disabled selected>
                                        Select a year
                                      </option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                    {fieldErrors.year !== "" ? (
                                      <div className="text-danger">
                                        {fieldErrors.year}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label
                                    htmlFor="field-2"
                                    className="form-label"
                                  >
                                    Estimated Activity Budget (Total Annual
                                    Budget)
                                  </label>
                                  <div className="input-group">
                                    <span
                                      className="input-group-text"
                                      id="basic-addon1"
                                    >
                                      LKR
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="field-2"
                                      placeholder="Estimated Budget"
                                      aria-describedby="basic-addon1"
                                      value={budget}
                                      disabled
                                      onChange={(e) =>
                                        setBudget(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="divider"></div>

                                <div className="mt-4">
                                  <h5 className="mb-3">Budget Activities</h5>
                                  {activities.map((activity, activityIndex) => (
                                    <div
                                      key={activityIndex}
                                      className="card mb-4 p-3 shadow-sm"
                                    >
                                      <h6 className="card-title">
                                        Activity {activityIndex + 1}
                                      </h6>
                                      <div className="row g-3">
                                        <div className="col-md-6">
                                          <label className="form-label">
                                            Activity Name
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Activity Name"
                                            value={activity.name}
                                            onChange={(e) =>
                                              handleActivityChange(
                                                activityIndex,
                                                "name",
                                                e.target.value
                                              )
                                            }
                                          />
                                          {subbudgetErrors[
                                            `activity-${activityIndex}-name`
                                          ] && (
                                            <div className="text-danger">
                                              {
                                                subbudgetErrors[
                                                  `activity-${activityIndex}-name`
                                                ]
                                              }
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-md-5">
                                          <label className="form-label">
                                            Activity Value (LKR)
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Activity Value"
                                            value={activity.value}
                                            disabled
                                            onChange={(e) =>
                                              handleActivityChange(
                                                activityIndex,
                                                "value",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="col-md-1 d-flex align-items-end">
                                          <button
                                            className="btn btn-danger"
                                            onClick={() =>
                                              handleDeleteActivity(
                                                activityIndex
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                      </div>

                                      <div className="mt-3 p-2 border rounded bg-light">
                                        <h6>Sub-Activities</h6>
                                        {subbudgetErrors[
                                          `activity-${activityIndex}-subbudgets`
                                        ] && (
                                          <div className="text-danger">
                                            {
                                              subbudgetErrors[
                                                `activity-${activityIndex}-subbudgets`
                                              ]
                                            }
                                          </div>
                                        )}
                                        {activity.subBudgets.map(
                                          (subBudget, subBudgetIndex) => (
                                            <div
                                              key={subBudgetIndex}
                                              className="row g-3 align-items-center mb-2"
                                            >
                                              <div className="col-md-4">
                                                <label className="form-label">
                                                  Sub-Activity Type
                                                </label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Subbudget Name"
                                                  value={subBudget.name}
                                                  onChange={(e) =>
                                                    handleSubBudgetChange(
                                                      activityIndex,
                                                      subBudgetIndex,
                                                      "name",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                {subbudgetErrors[
                                                  `${activityIndex}-${subBudgetIndex}`
                                                ] && (
                                                  <div className="text-danger">
                                                    {
                                                      subbudgetErrors[
                                                        `${activityIndex}-${subBudgetIndex}`
                                                      ]
                                                    }
                                                  </div>
                                                )}
                                              </div>
                                              <div className="col-md-4">
                                                <label className="form-label">
                                                  Sub-Activity Value (LKR)
                                                </label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="Sub-Activity Value"
                                                  value={subBudget.amount}
                                                  onChange={(e) =>
                                                    handleSubBudgetChange(
                                                      activityIndex,
                                                      subBudgetIndex,
                                                      "amount",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div className="col-md-4 mt-5 d-flex align-items-end">
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={() =>
                                                    handleDeleteSubBudget(
                                                      activityIndex,
                                                      subBudgetIndex
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-trash"></i>{" "}
                                                  &nbsp; Delete Sub-Activity
                                                  Type
                                                </button>
                                              </div>
                                            </div>
                                          )
                                        )}
                                        <button
                                          className="btn btn-success mt-2"
                                          onClick={() =>
                                            handleAddSubBudgetToActivity(
                                              activityIndex
                                            )
                                          }
                                        >
                                          Add Sub-Activity
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                  <button
                                    className="btn btn-success"
                                    onClick={handleAddActivity}
                                  >
                                    Add Activity
                                  </button>
                                </div>

                                <div className="divider"></div>
                                <div className="modal-body">
                                  <FileUpload
                                    onFileSelect={handleFileSelect}
                                    clear={clearFileUploader}
                                  />
                                  {fieldErrors.file !== "" ? (
                                    <div className="text-danger">
                                      {fieldErrors.file}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-cancel waves-effect"
                                data-bs-dismiss="modal"
                                onClick={handleClear}
                              >
                                Close
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={handleSubmit}
                              >
                                Add Budget
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 text-end">
                        {roleId !== 3 && (
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light mt-1 me-1"
                            data-bs-toggle="modal"
                            data-bs-target="#con-close-modal"
                            onClick={() => {
                              setInitalError(false);
                              setFieldErrors({ file: "" });
                            }}
                          >
                            Request New Budget
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xl-12 mt-3">
                        <div className="table-responsive custom-table">
                          <Table dataSource={campaignList} columns={columns} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default CreateBudget;
